import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { EmployeeData, EmployeeInsurance, Message, PrivilegeType } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DataService } from 'src/app/shared/services/data.service';
import { SettingsService } from 'src/app/shared/services/settings.service';
import { EmployeeInsuranceCrudComponent } from '../employee-insurance-crud/employee-insurance-crud.component';
import { CompanyService } from 'src/app/shared/services/company.service';
@Component({
  selector: 'app-employee-insurance-list',
  templateUrl: './employee-insurance-list.component.html',
  styleUrls: ['./employee-insurance-list.component.scss']
})
export class EmployeeInsuranceListComponent implements OnInit {
  public empInsurances: EmployeeInsurance[] = [];
  public isLoading: boolean = true;
  public searchKeyword: string = "";
  public privilege: PrivilegeType;
  public context: Context;
  public employees: EmployeeData[] = [];
  public employeeId: any;
  public employeeName: any;
  public empStatus: boolean;
  private subscription: any;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private settingsService: SettingsService,
    private dataService: DataService,
    private companyService: CompanyService,
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.context = this.authService.getContextData();
    this.companyService.getEmployees(this.context?.companyId).subscribe((employees: EmployeeData[]) => {
      this.employees = employees;
      const employeeIds = this.employees.filter((employee) => employee.employeeData?.id).map((employee) => employee.employeeData.id);
      this.employeeId = employeeIds.length > 0 ? employeeIds[0] : null;
      this.getEmpInsurances();
    });
    if (this.context?.employeeId) {
      this.subscription = this.authService.getContext().subscribe(context => {
        if (context?.employeeId) {
          this.context = context;
          this.getEmpInsurances();
        }
      });
    }
  }
  public getTruncatedName(name: string, maxLength: number): string {
    if (name.length > maxLength) {
      return name.slice(0, maxLength) + '...';
    }
    return name;
  }

  public getEmpInsurances(clear: boolean = true) {
    if (clear) {
      this.isLoading = true;
      this.empInsurances = [];
    }
    if (this.context?.persona === 'CLIENT') {
      this.settingsService.getEmpInsurances(this.employeeId, false, false).subscribe({
        next: (empInsurances: EmployeeInsurance[]) => {
          this.empInsurances = empInsurances.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.settingsService.getEmpInsurances(this.context.employeeId, false, false).subscribe({
        next: (empInsurances: EmployeeInsurance[]) => {
          this.empInsurances = empInsurances.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    }
  }

  onEmployeeChange(event: Event): void {
    let selectedEmployeeId = (event.target as HTMLSelectElement).value;
    if (selectedEmployeeId) {
      this.employeeId = selectedEmployeeId;
      const selectedEmployee = this.employees.find(employee => employee.employeeData?.id === Number(selectedEmployeeId));
      if (selectedEmployee) {
        let employeeName = selectedEmployee.employeeData?.name
        this.employeeName = employeeName;
        if (this.context?.persona === 'CLIENT') {
          this.getEmpInsurances();
        }
      }
    }
  }

  public deleteEmpInsurance(empInsurance: EmployeeInsurance, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Employee Insurance deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete Insurance";
    modalRef.componentInstance.message = empInsurance.policy;
    modalRef.componentInstance.label = 'insurance';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        empInsurance.isDeleteInProgress = true;
        this.settingsService.deleteEmpInsurance(empInsurance.id).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, message.text);
              this.empInsurances.splice(index, 1);
              this.getEmpInsurances(false);
              empInsurance.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, message.text);
              empInsurance.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
            empInsurance.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertEmpInsurance(empInsurance?: EmployeeInsurance) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(EmployeeInsuranceCrudComponent, { size: 'xl', backdrop: 'static' });
    modalRef.componentInstance.empInsurance = empInsurance;
    modalRef.componentInstance.context = this.context;
    modalRef.componentInstance.selectedEmployeeId = this.employeeId;
    modalRef.componentInstance.employeeName = this.employeeName;
    modalRef.componentInstance.passEntry.subscribe((response: Message) => {
      if (response) {
        this.getEmpInsurances(false);
      }
    })
  }

  public toggleEmpInsuranceStatus(empInsurance: EmployeeInsurance) {
    if (!this.privilege.canEdit) {
      setTimeout(() => { empInsurance.active = empInsurance.active }, 0);
      return;
    }
    this.settingsService.toggleEmpInsuranceStatus(empInsurance).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.getEmpInsurances(false);
          this.commonService.setToastr(200, response.text);
        } else {
          setTimeout(() => { empInsurance.active = empInsurance.active }, 0);
          this.commonService.setToastr(500, response.text);
        }
      },
      error: (error: HttpErrorResponse) => {
        setTimeout(() => { empInsurance.active = empInsurance.active }, 0);
        this.commonService.setToastr(500, error?.error?.name || error.error);
        empInsurance.isDeleteInProgress = false;
      },
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}